import Vue from "vue"
Vue.config.productionTip = false

import App from "./App.vue"
import router from "./router"
import store from "./store"

import i18n from "./locales/i18n"
import VueMoment from "vue-moment"
import moment from "moment"

import "fetch-polyfill"

/* Load Styled Components */
import "./components/styled"

/* Directives & Common & Plugin & Helpers */
import "./components/directives"
import "./components/common"
import "./components/plugins"
import "./components/prototypes"
import "./components/filters"

/* Load Style Resources */
import "./resources/scss/app.scss"

Vue.use(VueMoment, { moment })

import init from "@/init"

init
  .start()
  .then(res => {
    if (!res) throw "Bridge could not be started."
    return true
  })
  .then(() => {
    new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
    }).$mount("#app")
  })
  .then(() => document.getElementById("app").classList.remove("init"))
  .catch(err => {
    if (typeof err === "object") document.getElementById("app").innerHTML = err.message
    else document.getElementById("app").innerHTML = err
  })
